const isMobileView = () => {
  const viewportWidth = window.innerWidth;
  if (viewportWidth < WINDOW_MOBILE_WIDTH) {
    return true;
  }
  return false;
};
